import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';

import iconLibrary from 'src/app/common/iconLibrary';
import { TableSorter } from 'src/app/table-handling';

import { SortArrowState, SortArrowStates } from './sort-arrows-state';

@Component({
  selector: 'app-sort-arrows',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sort-arrows.component.html',
  styleUrls: ['./sort-arrows.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SortArrowsComponent {
  @Input() public sorter: TableSorter;
  @Input() public columnIndex: number;

  protected readonly iconLibrary = iconLibrary;

  public get state(): SortArrowState {
    if (!this.sorter || this.sorter.sortedColumnIndex === null) {
      return SortArrowStates.NO_COLUMN_SELECTED;
    }

    if (this.sorter.sortedColumnIndex !== this.columnIndex) {
      return SortArrowStates.OTHER_COLUMN_SELECTED;
    }

    return this.sorter.ascending ? SortArrowStates.UP : SortArrowStates.DOWN;
  }

  public get iconName(): string {
    const state: SortArrowState = this.state;

    switch(state) {
      case SortArrowStates.DOWN:
        return 'system/sort-down';

      case SortArrowStates.UP:
        return 'system/sort-up';

      case SortArrowStates.NO_COLUMN_SELECTED:
      case SortArrowStates.OTHER_COLUMN_SELECTED:
      default:
        return 'system/sort-up';
    }
  }

  public get iconColor(): 'currentColor' | 'primary' {
    switch (this.state) {
      case SortArrowStates.DOWN:
      case SortArrowStates.UP:
        return 'primary';

      default:
        return 'currentColor';
    }
  }
}
